import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    UPDATE_EXTRA,
    UPDATE_EXTRA_SUCCESS,
    UPDATE_EXTRA_ERROR,
}
    from "../../../actions/menu/extras";

function* updateExtraSaga(action) {
    try {
        const data =  yield call(extraService.UpdateExtra, action.payload)
        yield put({
            type: UPDATE_EXTRA_SUCCESS,
            payload: data
        });


    } catch (error) {
        yield put({
            type: UPDATE_EXTRA_ERROR,error: error.data
        });
    }
}


export function* updateExtraSagaWatcher() {
    yield takeLatest(UPDATE_EXTRA, updateExtraSaga);
}